/*
 * @Author: yzr
 * @Date: 2020-12-03 10:31:51
 * @LastEditors: yzr
 * @LastEditTime: 2020-12-03 10:34:38
 */
import RuleRender from './rule_render.vue';

export default RuleRender;
